import { render, staticRenderFns } from "./DecidedElites.vue?vue&type=template&id=28ff7700&scoped=true&"
import script from "./DecidedElites.vue?vue&type=script&lang=js&"
export * from "./DecidedElites.vue?vue&type=script&lang=js&"
import style0 from "./DecidedElites.vue?vue&type=style&index=0&id=28ff7700&prod&lang=css&"
import style1 from "./DecidedElites.vue?vue&type=style&index=1&id=28ff7700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff7700",
  null
  
)

export default component.exports